import React from 'react'

import Script from 'next/script'

import { useAppContext } from 'context/AppContext'
const isProdEnv = process.env.NODE_ENV === 'production'

const SplashElement = () => {
  const { userAgent = {} } = useAppContext()

  return isProdEnv && !userAgent.isBot ? (
    <>
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `
        var element = document.createElement('div');
        element.id = 'splash-element';
        element.setAttribute("style", 'position: fixed; inset: 0; z-index: 9999; background: rgba(255, 255, 255, .01)');
        element.onclick = () => console.log('splash clicked');
        document.getElementsByTagName('body')[0].appendChild(element);
      `,
        }}
      />
      <Script id="splash-script-after">{`document.getElementById('splash-element').remove()`}</Script>
    </>
  ) : null
}
export default SplashElement
